// A single PowerShell statement avoids the extra prompt caused by multiline pastes.
function quote(value) { return "'" + String(value).replace(/'/g, "''") + "'"; }
function buildVerificationCommand(release, t) {
 const file=quote('.\\'+release.filename);
 return [
  '& {',
  " $ErrorActionPreference = 'Stop';",
  ' try {',
  ` if (-not (Test-Path -LiteralPath ${file} -PathType Leaf)) { Write-Host ${quote(t.resultMissing)} -ForegroundColor Yellow; return };`,
  ` $fileHash = (Get-FileHash -Algorithm SHA256 -LiteralPath ${file}).Hash;`,
  ` $sig = Get-AuthenticodeSignature -LiteralPath ${file};`,
  " $signerHash = '';",
  " if ($sig.SignerCertificate) { $signerHash = [BitConverter]::ToString([Security.Cryptography.SHA256]::Create().ComputeHash($sig.SignerCertificate.RawData)).Replace('-','') };",
  ` $fileOk = $fileHash -eq ${quote(release.sha256)};`,
  ` $signerOk = $signerHash -eq ${quote(release.certificateSha256)};`,
  ` Write-Host ${quote('StarTax Desktop '+release.version)} -ForegroundColor Cyan;`,
  ` Write-Host (${quote(t.fileHash+': ')} + $fileHash);`,
  ` Write-Host (${quote(t.certHash+': ')} + $signerHash);`,
  ` if ($fileOk -and $signerOk) { Write-Host ${quote(t.resultOriginal)} -ForegroundColor Green }`,
  ` else { Write-Host ${quote(t.resultMismatch)} -ForegroundColor Red };`,
  ` } catch { Write-Host ${quote(t.resultError)} -ForegroundColor Yellow; Write-Host $_.Exception.Message };`,
  ' }'
 ].join('');
}
module.exports={buildVerificationCommand};
